import axios from 'axios'
import { URLS } from '../../util/urls'
import tools from '../../util/tools'
import { ROLE_RIGHTS } from '../../config/Right'

const state = {
  curButtonRights: [], // 用户拥有的按钮权限
  curNoButtonRights: [] // 用户不拥有的按钮权限
}

const getters = {
  // 判断是否有按钮权限(即： 在“用户拥有的权限”，且不在“用户不拥护的权限”)
  judgeHasButtonRight: state => rightName => {
    console.log('调试代码')
    var indexRight = -1
    var indexNoRight = -1
    if (state.curButtonRights) {
      indexRight = state.curButtonRights.indexOf(rightName.name)
    }
    if (state.curNoButtonRights) {
      indexNoRight = state.curNoButtonRights.indexOf(rightName.name)
    }
    return indexRight != -1 && indexNoRight === -1
  }
}

const actions = {
  // 根据登录用户的角色权限集，读取按钮权限集
  setCurButtonRights: ({ commit }, roleRightsLogin) => {
    var curRightsTmp = []
    roleRightsLogin.forEach(roleRightLogin => {
      if (ROLE_RIGHTS[roleRightLogin]) {
        ROLE_RIGHTS[roleRightLogin].buttonRights.forEach(right => {
          curRightsTmp.push(right.name)
        })
      }
    })

    commit('setCurButtonRights', [...new Set(curRightsTmp)])
  }
}

const mutations = {
  setCurButtonRights: (state, payload) => {
    state.curButtonRights = payload.slice(0)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
